var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9","cy":"9","r":"9","key":0}),React.createElement("path",{"d":"M7.84659 10.7755L4.84386 7.7728L3.27295 9.33551L7.84659 13.9091L15.2102 6.54553L13.7211 4.90918L7.84659 10.7755Z","key":1})]);
}

IconCheck.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
